export const projectsData = [
  {
    id: 'do-co',
    name: 'Documentos Constructivos',
    type: 'Web development - React site',
    link: 'https://do-co.mx/',
    image: 'do-co-lab.jpg',
    company: 'Independent',
    role: ['Web developer'],
    tech: ['React', 'SCSS', 'Bootstrap'],
    about:
      'This project serves as a comprehensive digital archive for a renowned architect, meticulously designed to bridge the gap between artistic vision and structural precision. By highlighting detailed blueprints and a unique explaining methodology, the site transforms a traditional portfolio into an immersive journey through the architectural process.',
    explain: [
      {
        background:
          'DoCo is a firm that helps design agencies, architects, and interior designers optimize the development of their executive projects. The main goal was to reflect their technical precision through a clean and minimalist interface, giving full prominence to their construction blueprints.',
        challenge:
          'The project required an information architecture capable of organizing an extensive portfolio of complex blueprints (from electrical to finishes) without overwhelming the user, while also reflecting their 3-step methodology: Planning, Development, and Tracking.',
        features: [
          {
            title: 'Multilingual Hero Section',
            description:
              "Dynamic transition on the homepage that alternates the company's motto in several languages, emphasizing that blueprint drafting is a universal language.",
          },
          {
            title: 'Architectural Index Carousels',
            description:
              'Interactive navigation that neatly groups blueprints into specific categories (Demolitions, Lighting, Bathroom Details) to facilitate smooth exploration.',
          },
          {
            title: 'DWG Template Lead Magnet',
            description:
              "Integration of a direct download system for DoCo's base drawing protocol, providing immediate value to the architectural community and generating user retention.",
          },
        ],
        result:
          'An elegant, structured, and fast digital ecosystem that serves both as a presentation letter for international firms and as a validation tool for technical quality.',
      },
    ],
  },
  {
    id: 'get-it-free',
    name: 'Get It Free',
    type: 'Web design and development - Drupal CMS',
    link: 'https://try.scored-ittt.com/aa/IC0011/2?vid=100&zDc=Desktop&zEx=&zVr=IC0011&utm_content=txhsgc&utm_source=testing&zRid=AA&zct=txhsgc',
    image: 'gif-lab.jpg',
    company: 'Zeeto',
    role: ['Web developer', 'Web designer'],
    tech: ['Drupal'],
    about: 'A high-conversion Drupal-based platform designed for sweepstakes, free samples, and lead generation, focusing on user engagement and seamless user flows.',
    explain: [
      {
        background: 'Developed for Zeeto, Get It Free is a digital property aimed at connecting users with rewards and promotional offers. The project required a robust CMS structure to handle dynamic content delivery and high volumes of traffic.',
        challenge: 'The primary challenge was designing and developing a highly optimized, fast-loading landing page funnel capable of managing massive concurrent traffic while preserving strict marketing tracking parameters (UTMs, vids).',
        features: [
          {
            title: 'Dynamic Lead Generation Funnel',
            description: 'Custom Drupal implementation designed to guide the user seamlessly from the initial click to the final conversion.'
          },
          {
            title: 'Marketing Tracking Integration',
            description: 'Flawless handling of URL parameters and tracking tags to ensure the ad-tech ecosystem accurately attributed every lead.'
          },
          {
            title: 'Responsive UI/UX Design',
            description: 'Created a visually appealing, mobile-first design to maximize engagement and reduce bounce rates across all devices.'
          }
        ],
        result: 'A highly performant, scalable sweepstakes platform that significantly improved conversion rates and integrated perfectly with Zeeto’s ad-tech infrastructure.'
      }
    ]
  },
  {
    id: 'prizies',
    name: 'Prizies',
    type: 'Web development - Drupal CMS',
    link: 'https://3.prizies.com/n?vid=100&zDc=Desktop&zEx=&zVr=IZ0000&utm_content=pr_wlmt_1000&utm_source=testing&zRid=IZ',
    image: 'prizies-lab.jpg',
    company: 'Zeeto',
    role: ['Web developer'],
    tech: ['Drupal'],
    about: 'An interactive sweepstakes and rewards landing page built with Drupal, optimized for rapid user acquisition, data collection, and scalability.',
    explain: [
      {
        background: 'Prizies is part of Zeeto’s network of promotional websites. The objective was to build a reliable and easily replicable environment for various marketing campaigns and prize giveaways.',
        challenge: 'It was crucial to ensure lightning-fast page loads and pixel-perfect responsiveness to streamline the user journey from the advertising click to the final data capture, all while maintaining backend stability.',
        features: [
          {
            title: 'High-Conversion Architecture',
            description: 'Developed a streamlined user flow in Drupal that eliminates friction during the registration and reward-claiming process.'
          },
          {
            title: 'A/B Testing Readiness',
            description: 'Built a flexible templating system that allows the marketing team to easily swap assets and test different campaign variations.'
          },
          {
            title: 'Seamless Data Capture',
            description: 'Secure and efficient form integrations that sync user data instantly with the company’s core marketing databases.'
          }
        ],
        result: 'A stable and conversion-optimized web property that empowered the marketing team to quickly deploy new campaigns and maximize overall user engagement.'
      }
    ]
  }
  // {
  //   id: 'scored-it',
  //   name: 'Scored It',
  //   type: 'Web development - Drupal CMS',
  //   link: 'https://try.scoredit.com/w?vid=100&zDc=Desktop&zEx=&zVr=CC0000&utm_content=txhsgc&utm_source=testing&zRid=CC',
  //   image: 'scoredIt-lab.jpg',
  //   role: ["Web developer"],
  //   explain: '',
  //   company: 'Zeeto',
  //   tech: ["Drupal", "Firebase"]
  // },
  // {
  //   id: 'your-ebook-resources',
  //   name: 'Your Ebook Resources',
  //   type: 'Web design and development - Drupal CMS',
  //   link: 'https://try.yourebookresource.com/x?zDc=Desktop&zEx=&zVr=EA0000&utm_content=ebr_astrology&utm_source=testing&zRid=EA',
  //   image: 'zodiac-lab.jpg',
  //   role: ["Web developer", "Web designer", "UX/UI Designer", "Copywriter"],
  //   explain: [{
  //     "background": "asdasdasd"
  //   }],
  //   company: 'Zeeto',
  //   tech: ["Drupal"]
  // },
]
